<!--
create by melody on 2018/11/1
description:租赁物件详细信息
-->
<template>
<div>
    <page-header :title="title"  v-if="title.isShow===0"></page-header>
    <div class="table-container">
        <p>
            <el-button v-if="title.isShow===0"  type="text" icon="el-icon-arrow-left" @click="close">{{$t('m.back')}}</el-button>
        </p>
        <el-tabs type="border-card" v-model="searchParam.type"  @tab-click="handleTabClick">
            <el-tab-pane v-for="(item, index) in navTypeList" :disabled="tabDisableFlag" :key="index" :label="item.label" :name="item.value">
            </el-tab-pane>
            <div class="">
                <el-table ref="multipleTable" v-loading="loading" :data="tableData" :key="searchParam.type" stripe tooltip-effect="dark" style="width: 100%;margin: 24px 0" height="500">
                    <el-table-column v-for="(item, index) in tableItemList" :key="index" :prop="item.value" :label="item.label" :width="item.width" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span v-if="item.type=='money'">{{$commonFunc.format(scope.row[item.value])}}</span>
                            <span v-else-if="item.value=='closeFlag'">{{scope.row[item.value] == true ? 'Y' : 'N'}}</span>
                            <span v-else >{{scope.row[item.value]}}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-tabs>
    </div>
</div>
</template>
<script>
import {
    mapState,
    mapGetters
} from 'vuex'
export default {
    name: 'OprateDetail',
    props: ['paramsObj'], //调用组件传递过来的相关参数
    data () {
        return {
            title: {
                firstTitle: this.$t('m.LapModule'),
                secondTitle: this.$t('m.OPERATE_MANAGE'),
                thirdTitle: this.paramsObj.fromPageName,
                fourTitle: this.$t('m.operateDetail'),
                isShow: this.paramsObj.isShowPageType
            },
            searchParam: {
                leaseItemNumber:  this.paramsObj.leaseItemNumber,
                headerId:  this.paramsObj.headerId,
                type: '116'
            },
            tableData: [],
            loading: true,
            tableItemList:[],
            computeHeader: [],//头表 合同信息 物件信息 和资产信息来源
            computeMiddleList: [],//付款计划来源
            computePaymentPlanItemList: [],//还本付息来源
            accountingAssetDetailVOS: [], //资产信息表来源
            accountingUsefulPlanList: [], //折旧信息表来源
            accountingUsefulPlanListUS: [], //折旧信息表来源(美国)
            tabDisableFlag: true,
            contactTableItem: [
            {
                value: 'leaseItemStatus',
                label: this.$t('m.leaseItemStatus'),
                width: 100
            },
            {
                value: 'transactionType',
                label: this.$t('m.transactionType'),
                width: 150
            },
            {
                value: 'ouName',
                label: this.$t('m.ouName'),
                width: 250
            },
            {
                value: 'currency',
                label: this.$t('m.currency'),
                width: 100
            },
            {
                value: 'headerType',
                label: this.$t('m.leaseType'),
                width: 100
            },
            {
                value: 'costCenter',
                label: this.$t('m.costCenter'),
                width: 100
            },
            {
                value: 'poNumber',
                label: this.$t('m.poNumber'),
                width: 200
            },
            {
                value: 'contractNumber',
                label: this.$t('m.contractNumber'),
                width: 200
            },
            {
                value: 'headerSource',
                label: this.$t('m.dataSource'),
                width: 150
            },
            {
                value: 'referenceContractNumber',
                label: this.$t('m.referenceContractNumber'),
                width: 200
            },
            {
                value: 'contractStartDate',
                label: this.$t('m.contractStartDate'),
                width: 150
            },
            {
                value: 'contractEndDate',
                label: this.$t('m.contractEndDate'),
                width: 150
            },
            {
                value: 'extensionRightFlag',
                label: this.$t('m.extensionRightFlag'),
                width: 150
            },
            {
                value: 'extensionFlag',
                label: this.$t('m.extensionFlag'),
                width: 150
            },
            {
                value: 'extensionTerm',
                label: this.$t('m.extensionTerm'),
                width: 200
            },
            {
                value: 'terminateFrom',
                label: this.$t('m.terminateFrom'),
                width: 200
            },
            {
                value: 'controlDateTo',
                label: this.$t('m.controlDateTo'),
                width: 200
            },
            {
                value: 'countryRegion',
                label: this.$t('m.region'),
                width: 150
            },
            {
                value: 'contractCurrency',
                label: this.$t('m.contractCurrency'),
                width: 150
            },
            {
                value: 'startRate',
                label: this.$t('m.startRate'),
                width: 150
            },
            {
                value: 'purchaseRightFlag',
                label: this.$t('m.purchaseRightFlag'),
                width: 150
            },
            {
                value: 'shortTermExemptionFlag',
                label: this.$t('m.shortTermExemptionFlag'),
                width: 200
            },
            {
                value: 'purchaseValue',
                label: this.$t('m.purchaseValue'),
                width: 200
            },
            {
                value: 'lowValueExemptionFlag',
                label: this.$t('m.lowValueExemptionFlag'),
                width: 200
            },
            {
                value: 'variableExemptionFlag',
                label: this.$t('m.variableExemptionFlag'),
                width: 150
            }
            ],

            rentalTableList: [
            {
                value: 'leaseItemCategory',
                label: this.$t('m.leaseItemCategory'),
                width: 180
            },
            {
                value: 'leaseItemDescription',
                label: this.$t('m.leaseItemDescription'),
                width: 420
            },
            {
                value: 'leaseItemComment',
                label: this.$t('m.leaseItemComment'),
                width: 180
            },
            {
                value: 'leaseItemNumber',
                label: this.$t('m.leaseItemNumber'),
                width: 250
            },
            {
                value: 'poLineNumber',
                label: this.$t('m.poLineNumber'),
                width: 150
            },
            {
                value: 'deliveryBatchNumber',
                label: this.$t('m.deliveryBatchNumber'),
                width: 180
            },
            {
                value: 'leaseStartDate',
                label: this.$t('m.leaseStartDate'),
                width: 150
            },
            {
                value: 'leaseEndDate',
                label: this.$t('m.leaseEndDate'),
                width: 150
            },
            {
                value: 'leaseTerm',
                label: this.$t('m.leaseTerm'),
                width: 150
            },
            {
                value: 'leaseItemType',
                label: this.$t('m.leaseItemType'),
                width: 150
            },
            {
                value: 'taxRate',
                label: this.$t('m.taxRate'),
                width: 100
            },
            {
                value: 'referenceValue',
                label: this.$t('m.referenceValue'),
                width: 150
            },
            {
                value: 'discountRateType',
                label: this.$t('m.discountRateType'),
                width: 150
            },
            {
                value: 'discountRateSource',
                label: this.$t('m.discountRateSource'),
                width: 160
            },
            {
                value: 'annualDiscountRate',
                label: this.$t('m.annualDiscountRate'),
                width: 160
            },
            {
                value: 'financeLeaseFlag',
                label: this.$t('m.financeLeaseFlag'),
                width: 150
            },
            {
                value: 'subleaseFlag',
                label: this.$t('m.subleaseFlag'),
                width: 150
            },
            {
                value: 'transitionOption',
                label: this.$t('m.transitionOption'),
                width: 150
            },
            {
                value: 'serialNumber',
                label: this.$t('m.serialNumber'),
                width: 150
            },
            {
                value: 'originalLeaseItemNumber',
                label: this.$t('m.originalLeaseItemNumber'),
                width: 250
            },
            {
                value: 'originalPoNumber',
                label: this.$t('m.originalPoNumber'),
                width: 150
            },
            {
                value: 'originalPoLineNumber',
                label: this.$t('m.originalPoLineNumber'),
                width: 180
            },
            {
                value: 'originalDeliveryBatchNumber',
                label: this.$t('m.originalDeliveryBatchNumber'),
                width: 220
            },
            {
                value: 'revaluationDate',
                label: this.$t('m.revaluationDate'),
                width: 150
            },
            {
                value: 'poVarchargeAccount',
                label: this.$t('m.poVarchargeAccount'),
                width: 180
            },
            {
                value: 'partialCancelPercentage',
                label: this.$t('m.partialCancelPercentage'),
                width: 200
            },
            {
                value: 'assetAdjAmount',
                label: this.$t('m.assetAdjAmount'),
                type: 'money',
                width: 180
            },
            {
                value: 'pandlAdj',
                label: this.$t('m.pandlAdj'),
                type: 'money',
                width: 220
            },
            {
                value: 'liabilityAdjUstment',
                label: this.$t('m.liabilityAdjUstment'),
                type: 'money',
                width: 180
            },
                {
                    value: 'oldBeginningBalance',
                    label: this.$t('m.oldBeginningBalance'),
                    width: 150
                },
            {
                value: 'vendorName',
                label: this.$t('m.vendorName'),
                width: 250
            },
            {
                value: 'headerComment',
                label: this.$t('m.comment'),
                width: 150
            },
            {
                value: 'modificationReason',
                label: this.$t('m.modificationReason'),
                width: 150
            }

            ],
            payTableItem: [
            {
                value: 'paymentDateFrom',
                label: this.$t('m.paymentDateFrom'),
                width: 200
            },
            {
                value: 'paymentDateTo',
                label: this.$t('m.paymentDateTo'),
                width: 150
            },
            {
                value: 'leasePaymentType',
                label: this.$t('m.leasePaymentType'),
                width: 180
            },
            {
                value: 'frequentFlag',
                label: this.$t('m.frequentFlag'),
                width: 200
            },
            {
                value: 'paymentFrequency',
                label: this.$t('m.paymentFrequency'),
                width: 150
            },
            {
                value: 'usedCount',
                label: this.$t('m.usedCount'),
                width: 200
            },
            {
                value: 'unitType',
                label: this.$t('m.unitType'),
                width: 100
            },
            {
                value: 'unitPrice',
                label: this.$t('m.unitPrice'),
                type: 'money',
                width: 100
            },
            {
                value: 'periodFlag',
                label: this.$t('m.periodFlag'),
                width: 200
            }],
            repaymentTableItem: [
            {
                value: 'periodName',
                label: this.$t('m.periodName'),
                width: 150
            },
            {
                value: 'beginBalances',
                label: this.$t('m.beginBalances'),
                type: 'money',
                width: 150
            },
            {
                value: 'paymentAmount',
                label: this.$t('m.paymentAmount'),
                type: 'money',
                width: 150
            },
            {
                value: 'interest',
                label: this.$t('m.interest'),
                type: 'money',
                width: 150
            },
            {
                value: 'principal',
                label: this.$t('m.principal'),
                type: 'money',
                width: 150
            },
            {
                value: 'endBalances',
                label: this.$t('m.endBalances'),
                type: 'money',
                width: 150
            },
            {
                value: 'faAccountedFlag',
                label: this.$t('m.faAccountedFlag'),
                width: 150
            },
            // {
            //     value: 'periodFlag',
            //     label: 'ERP凭证编号',
            //     width: 150
            // },
            {
                value: 'cfAccountedFlag',
                label: this.$t('m.cfAccountedFlag'),
                width: 200
            },
            {
                value: 'closeFlag',
                label: this.$t('m.closeFlag'),
                width: 200
            }],
            assetsTableItem: [
            {
                value: 'assetBook',
                label: this.$t('m.assetBook'),
                width: 200
            },
            {
                value: 'assetCategory',
                label: this.$t('m.assetCategory'),
                width: 200
            },
            {
                value: 'depreciationExpenseAccount',
                label: this.$t('m.depreciationExpenseAccount'),
                width: 220
            },
            {
                value: 'useright',
                label: this.$t('m.useright'),
                type: 'money',
                width: 200
            },
            {
                value: 'starttime',
                label: this.$t('m.starttime'),
                width: 200
            },
            {
                value: 'depreciation',
                label: this.$t('m.depreciation'),
                width: 200
            },
            {
                value: 'usefulMethod',
                label: this.$t('m.usefulMethod'),
                width: 200
            },
            {
                value: 'assetNumber',
                label: this.$t('m.assetNumber'),
                width: 200
            }
            ],
            discountTableItem: [
            {
                value: 'leaseItemNumber',
                label: this.$t('m.leaseItemNumber'),
                width: 250
            },
            {
                value: 'accountingPeriod',
                label: this.$t('m.accountingPeriod'),
                width: 200
            },
            {
                value: 'usefulAmount',
                label: this.$t('m.usefulAmount'),
                width: 200
            },
            {
                value: 'usefulTotalAmount',
                label: this.$t('m.usefulTotalAmount'),
                width: 200
            },
            {
                value: 'assetOriginalAmount',
                label: this.$t('m.assetOriginalAmount'),
                width: 200
            },
            {
                value: 'assetNetAmount',
                label: this.$t('m.assetNetAmount'),
                width: 200
            },
            {
                value: 'primaryLedger',
                label: this.$t('m.primaryLedger'),
                width: 200
            },
            {
                value: 'closeFlag',
                label: this.$t('m.closeFlag'),
                width: 200
            }],
            navTypeList: [],
            currentPage: 1,
            version: '全部版本',
            isShowType: this.paramsObj.from,
            isDisableAction: true,
            leaseStartDateFlag: ''
        }
    },
    methods: {
        handleSelectionChange(val) {
          if(val.length > 0) {
            this.isDisableAction = false
          }else{
            this.isDisableAction = true
          }
        },
        close () {
          this.$emit('close')
        },
        getDemoList() {
            this.tableData = []
            let url = this.paramsObj.from == 'EPOorderLeasing' ? '/compute/header/epo/detailInfo' : '/compute/header/getDetailLeaseInfo'
            let type = this.paramsObj.from == 'EPOorderLeasing' ? 'getDetailEPOLeaseInfo' : 'getDetailLeaseInfo'
            this.$commonFunc.commonRequest('get', url, type , this.searchParam)
            .then(res=>{
                this.loading = false
                if(!res.obj) {
                    this.tableData = []
                } else {
                    this.computeHeader.push(res.obj.computeHeader)
                    this.computeMiddleList = res.obj.computeMiddleList
                    if(this.paramsObj.from == 'EPOorderLeasing') {
                        this.computePaymentPlanItemList = []
                        this.accountingAssetDetailVOS = []
                        this.accountingUsefulPlanList = []
                        this.accountingUsefulPlanListUS = []
                    } else {
                        this.computePaymentPlanItemList = res.obj.computePaymentPlanItemList
                        this.accountingAssetDetailVOS = res.obj.accountingAssetDetailVOS
                        let arr = []
                        let arr_us = []
                        res.obj.accountingUsefulPlanList.forEach((o,i)=>{
                            if(o.usefulType == 1) {
                                arr.push(o)
                            } else {
                                arr_us.push(o)
                            }
                        })
                        this.accountingUsefulPlanList = arr
                        this.accountingUsefulPlanListUS = arr_us
                    }
                    this.tableItemList = this.contactTableItem
                    this.tableData = this.computeHeader
                    this.tabDisableFlag = false
                } 
                
            })
            .catch(res=>{
                this.$message.error(res.message)
                this.tabDisableFlag = false
            })
        },
        handleTabClick(tab, event) {
            if (tab.name == '116') {//合同信息
                this.tableData = this.computeHeader
                this.tableItemList = this.contactTableItem
            } else if(tab.name == '117') {//物件信息
                this.tableData = this.computeHeader
                this.tableItemList = this.rentalTableList
            } else if(tab.name == '118') {//付款计划
                this.tableData = this.computeMiddleList
                this.tableItemList = this.payTableItem
            } else if(tab.name == '119') {//还本付息计划
                this.tableData = this.computePaymentPlanItemList
                this.tableItemList = this.repaymentTableItem
            } else if(tab.name == '120') {//资产信息表 
                this.tableData = this.accountingAssetDetailVOS
                this.tableItemList = this.assetsTableItem
            } else if(tab.name == '121') { //折旧信息表
                this.tableData = this.accountingUsefulPlanList
                this.tableItemList = this.discountTableItem
            } else if(tab.name == '122') {//折旧信息表（美国准则）
                this.tableData = this.accountingUsefulPlanListUS
                this.tableItemList = this.discountTableItem
            }
        },
    },
    async mounted() {
        this.navTypeList = await this.$commonFunc.getDataDicList(this.$dataDicObj[this.$t('m.navDicData')], true)
        this.getDemoList()
    }
}
</script>
<style scoped lang="scss">
.search-container {
    background: #ffffff;
    /* padding: 10px 0 2px; */
}
.table-container {
    padding: 24px;
    margin: 32px 0;
    background: #ffffff;
}
.block {
    text-align: right;
}
.el-form-item .el-form-item__content {
    margin-left: 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/OprateDetail.vue